import { EmoticonLolIcon } from './EmoticonLolIcon';

/**
 * author: Michael Richins
 * id 11CEDEB3-DB1A-45F4-92C9-6AF6FCEE4FC5
 * name emoticon-lol
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-lol.svg
 * tags
 * - Emoji 
 */
export const FaceLolIcon = EmoticonLolIcon;
export default FaceLolIcon